@if (initialized && model) {
  <div>
    @if (step === 'contact') {
      <app-select-invoice-contact
        [customer]="model.customer"
        [subscription]="model.subscription"
        (back)="onContactBack()"
        [historyBack]="false"
        (selected)="onContact($event)"
        >
      </app-select-invoice-contact>
    }
    @if (step === 'address') {
      <app-invoice-address
        (next)="onInvoiceAddress($event)"
        (backEvent)="onInvoiceAddressBack()"
        [company]="model.company"
        [onlyEmit]="true"
        [historyBack]="false"
        >
      </app-invoice-address>
    }
    @if (isSepa && step === 'payment') {
      <app-payment-method
        (next)="onPaymentMethod($event)"
        (backEvent)="onPaymentMethodBack()"
        [company]="model.company"
        [onlyEmit]="true"
        [historyBack]="false"
        [paymentMethod]="model?.saleOrder?.payment_method ?? model?.subscription?.payment_method"
        >
      </app-payment-method>
    }
    @if (step === 'checkout') {
      <app-checkout-one-summary
        [subscription]="model.subscription"
        (back)="onSummaryBack()"
        [historyBack]="false"
        (buy)="onBuy()"
        >
      </app-checkout-one-summary>
    }
    @if (step === 'complete') {
      <app-partner-upgrade-offer-sent
        (next)="onComplete()"
        [customerEmail]="model.saleOrder.contact.email"
      ></app-partner-upgrade-offer-sent>
    }
  </div>
}
